import React from 'react';

// Gedeelde dadaïstische bouwstenen — exact dezelfde visuele taal als LandingPage.jsx
// Niets in deze file zet teksten in; alleen visuele primitives.

export const DADA = {
  cream: '#f6f1e8',
  ink: '#151827',
  green: '#3f7f65',
  purple: '#713d8d',
  mint: '#8fd6b6',
};

export function TornLabel({ children, className = '', bgColor = '#ffffff', textColor = '#151827' }) {
  return (
    <span
      className={`inline-block px-4 py-2 text-sm font-black uppercase tracking-tight shadow-xl sm:text-base ${className}`}
      style={{
        clipPath: 'polygon(0 13%, 94% 0, 100% 82%, 7% 100%)',
        backgroundColor: bgColor,
        color: textColor,
      }}
    >
      {children}
    </span>
  );
}

export function DadaBackdrop() {
  return (
    <>
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.10]"
        style={{
          backgroundImage: 'radial-gradient(#151827 1px, transparent 1px)',
          backgroundSize: '18px 18px',
        }}
      />
      <div className="pointer-events-none absolute -left-24 -top-32 h-96 w-96 rounded-full bg-[#3f7f65] opacity-25 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 top-10 h-[34rem] w-[34rem] rounded-full bg-[#713d8d] opacity-25 blur-3xl" />
    </>
  );
}

export function DadaStyles() {
  return (
    <style>{`
      @keyframes marquee {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
      @keyframes dada-in {
        0% { opacity: 0; transform: translateY(18px) rotate(-1deg); }
        100% { opacity: 1; transform: translateY(0) rotate(0); }
      }
      .animate-marquee {
        display: inline-block;
        animation: marquee 28s linear infinite;
      }
      .animate-dada-in {
        animation: dada-in 650ms ease-out both;
      }
      .animate-dada-in-delayed {
        animation: dada-in 800ms ease-out both;
        animation-delay: 120ms;
      }
    `}</style>
  );
}
